import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import theme from './theme';
import queryClient from './queryClient';
import HeaderLayout from '@layouts/HeaderLayout';
import AdminLayout from '@layouts/AdminLayout';

const Contact = lazy(() => import('@pages/contact'));
const BusinessContribute = lazy(() => import('@pages/contribute/business'));
const IndividualContribute = lazy(() => import('@pages/contribute/individual'));
const HomePage = lazy(() => import('@pages/home'));
const AdminPage = lazy(() => import('@pages/admin'));
const LoginPage = lazy(() => import('@pages/admin/login/LoginPage'));

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route element={<HeaderLayout />}>
                <Route path='/' element={<HomePage />} />
                <Route path='/dong-gop-ca-nhan' element={<IndividualContribute />} />
                <Route path='/dong-gop-doanh-nghiep' element={<BusinessContribute />} />
                <Route path='/lien-he' element={<Contact />} />
              </Route>
              <Route element={<AdminLayout />}>
                <Route path='/admin' element={<AdminPage />} />
                <Route path='/login' element={<LoginPage />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
